import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Folder = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-test="folder-icon" height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.8125 5.8125C12.8125 5.58044 12.7203 5.35788 12.5562 5.19378C12.3921 5.02969 12.1696 4.9375 11.9375 4.9375H6.6875L6.06917 4.31858C5.98788 4.23734 5.89138 4.17292 5.78518 4.12898C5.67899 4.08504 5.56518 4.06245 5.45025 4.0625H4.0625C3.83044 4.0625 3.60788 4.15469 3.44378 4.31878C3.27969 4.48288 3.1875 4.70544 3.1875 4.9375V11.0625C3.1875 11.2946 3.27969 11.5171 3.44378 11.6812C3.60788 11.8453 3.83044 11.9375 4.0625 11.9375H11.9375C12.1696 11.9375 12.3921 11.8453 12.5562 11.6812C12.7203 11.5171 12.8125 11.2946 12.8125 11.0625V5.8125Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
